import React from 'react';
import { compose, graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Route } from 'react-router-dom';
import LoadingIndicator from 'components/LoadingIndicator';
import { GUEST_TOKEN } from 'config/constants';
import AuthUserFragment from 'containers/Auth/graphql/userFragment.gql';

const USER_QUERY = gql`
  query User {
    user {
      ...AuthUserFragment
    }
  }
  ${AuthUserFragment}
`;

// eslint-disable-next-line react/prefer-stateless-function
class PublicRoute extends React.Component {
  async componentDidMount() {
    if (!this.props.isToken) {
      this.props.guest({
        update: (proxy, { data: { guest } }) => {
          localStorage.setItem(GUEST_TOKEN, guest.token);
          proxy.writeQuery({
            query: IS_TOKEN,
            data: {
              isToken: !!guest.token,
            },
          });
        },
        refetchQueries: () => [{ query: USER_QUERY }],
      });
    }
  }

  render() {
    const { component: Component, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={() =>
          this.props.isToken && this.props.user ? (
            <Component {...this.props} />
          ) : (
            <LoadingIndicator />
          )
        }
      />
    );
  }
}

const IS_TOKEN = gql`
  query IsToken {
    isToken
  }
`;

const GUEST = gql`
  mutation guest {
    guest {
      token
    }
  }
`;

export default compose(
  graphql(IS_TOKEN, {
    options: { fetchPolicy: 'cache-only' },
    props: ({ data: { isToken } }) => ({
      isToken,
    }),
  }),
  graphql(GUEST, {
    name: 'guest',
    options: () => ({
      errorPolicy: 'all',
    }),
  }),
  graphql(USER_QUERY, {
    skip: (ownProps) => !ownProps.isToken,
    props: ({ data: { user } }) => ({ user }),
  })
)(PublicRoute);



// WEBPACK FOOTER //
// ./app/components/PublicRoute/index.js